import React, { Component } from 'react';
import { GraingerAccountContext } from '../../Context/Context';

import './Footer.scss';
import { Row, Column } from '../Grid/Grid';
import Logo from '../Logo/Logo';

class Footer extends Component {
  getDetail(name, values) {
    return (
      <div className='footer-detail'>
        <span className='footer-detail-header'>{name}:</span>
        {values.map((value) => {
          return (<p>{value}</p>);
        })}
      </div>
    );
  }

  render() {
    const year = new Date().getFullYear();

    return (
      <footer>
        <div className='footer-container'>
          <Row>
            <Column className='footer-text-column'> 
              <Row className='footer-text-row'>
                <Column>
                  {this.getDetail('Office', ['Level 1', '8 - 10 Purdue St', 'Belconnen ACT 2617'])}
                  {this.getDetail('Phone', ['02 62533511'])}
                </Column>
                <Column>
                  {this.getDetail('Postal', ['PO Box 5', 'Belconnen', 'ACT 2616'])}
                  {this.getDetail('Email', ['admin@graingercpa.com.au'])}
                </Column >
                <Column>
                  {this.getDetail('Office Hours', ['Monday - Friday', '9am - 5pm'])}
                </Column>
              </Row>
            </Column>
            <Column className='footer-logo-column'>
              <Logo type='Small' size={100} />
            </Column>
          </Row>
          <hr className='footer-line' />
          <p className='footer-copyright'>
            Copyright &copy; {year} <br className='footer-copyright-break' /> Grainger Accounting
          </p>
        </div>
      </footer>
    );
  }
}

Footer.contextType = GraingerAccountContext;
export default Footer;